import { Stack } from "@chakra-ui/react";
import React from "react";
import FormikControl from "../../Formik/index";

export const CustomerRegisterForm = ({
  customername,
  phonenumber,
  address,
}) => {
  return (
    <Stack spacing="5">
      <FormikControl
        fontSize="20px"
        control="chakrainput"
        label="नाव"
        name={customername}
      />
      <FormikControl
        fontSize="20px"
        control="chakrainput"
        label="फोन"
        type="number"
        name={phonenumber}
      />
      <FormikControl
        fontSize="20px"
        control="chakrainput"
        label="पत्ता"
        name={address}
      />
    </Stack>
  );
};
